<template>
	<div class="user-watches-navigation">
		<div class="btn-group-navigation">
			<router-link v-check-user:patients="user_uid" :to="{ name: 'UserWatchesPatients', params: { user_uid } }">{{ $t('buttons.general.patients') }}</router-link>
			<router-link v-check-user:devices="user_uid" :to="{ name: 'UserWatchesDevices', params: { user_uid } }">{{ $t('buttons.general.devices') }}</router-link>
		</div>
		<div class="btn-group-navigation">
			<button :class="viewModeButtonClass('grid')" @click="setViewMode('grid')">{{ $t('buttons.general.grid') }}</button>
			<button :class="viewModeButtonClass('list')" @click="setViewMode('list')">{{ $t('buttons.general.list') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			viewMode: 'list'
		}
	},
	methods: {
		setViewMode (mode) {
			switch (mode) {
				case 'grid':
					this.viewMode = 'grid'
					break
				case 'list':
					this.viewMode = 'list'
					break
				default:
					this.viewMode = 'list'
			}
			this.$emit('viewMode', this.viewMode)
		},
		viewModeButtonClass (mode) {
			return this.viewMode === mode ? 'selected' : 'unselected'
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesNavigation.vue